
/**
 * 플랫폼 지원
 */
export type CourseDraftCreateLocalizedSectionsItemLecturesItemPlatformSupport = typeof CourseDraftCreateLocalizedSectionsItemLecturesItemPlatformSupport[keyof typeof CourseDraftCreateLocalizedSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftCreateLocalizedSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
